import React, { memo } from 'react';
import PropTypes from 'prop-types';

const LoadingSpinner = memo(({ message = 'Loading...', fullScreen = false, size = '1x' }) => {
  const containerClass = fullScreen
    ? 'd-flex justify-content-center align-items-center vh-100'
    : 'd-flex align-items-center p-3';

  return (
    <div className={containerClass}>
      <i className={`fa fa-spinner fa-spin fa-${size} me-2`} />
      {message}
    </div>
  );
});

LoadingSpinner.displayName = 'LoadingSpinner';

LoadingSpinner.propTypes = {
  message: PropTypes.string,
  fullScreen: PropTypes.bool,
  size: PropTypes.oneOf(['1x', '2x', '3x', 'lg']),
};

export default LoadingSpinner;
